import React, { Children, useState } from "react";
import { Link } from "react-router-dom";
import { Menu } from "antd";
import {
  CalendarOutlined,
  CodeSandboxOutlined,
  DownOutlined,
  ExperimentOutlined,
  PieChartOutlined,
  BarChartOutlined,
  FundOutlined,
  GlobalOutlined,
  AreaChartOutlined,
  CaretUpOutlined,
  CaretDownOutlined,
  ExportOutlined,
} from "@ant-design/icons";
import { isAuthenticated } from "@seims/shared/src/security";

export const MenuView = () => {
  const initialLandingPage = isAuthenticated() ? "my-programmes" : "home";

  const [current, setCurrent] = useState(initialLandingPage);
  const [collapsed, setCollapsed] = useState(false);
  const [activeMenu, setActiveMenu] = useState("");

  const onClick = (e) => {
    setCurrent(e.key);
  };

  const toggleCollapsed = (e) => {
    setActiveMenu([e]);
    setCollapsed(!collapsed);
  };

  const items = [
    !isAuthenticated() && {
      label: (
        <Link className="menu-link" to="/">
          Home
        </Link>
      ),
      key: "home",
    },

    isAuthenticated() && {
      label: (
        <Link className="menu-link logged-in-link" to="/">
          My Dashboard
        </Link>
      ),
      key: "my-programmes",
    },

    //   isAuthenticated() && (
    //   {
    //     label: (
    //       <Link className="menu-link logged-in-link" to="/events">
    //         My Dashboard
    //       </Link>
    //     ),
    //     key: "my-programmes",
    //   }
    // ),
  ];

  return (
    <div>
      <Menu
        mode="horizontal"
        style={{
          backgroundColor: "#1F6297",
          color: "white",
          border: "1px solid #707070",
          opacity: 1,
        }}
        onClick={onClick}
        selectedKeys={[current]}
        items={items}
        onOpenChange={toggleCollapsed}
        // expandIcon={<DownOutlined />}
      />
      {/* My programmes/initiatives space */}

      {/* {isAuthenticated() && (  
        <div className="logged-in-link">
          <Link className="menu-link" to="/portal/my-programmes">
          My Initiatives
        </Link>
        </div> 
      )
    } */}
    </div>
  );
};
